if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (!this.form) {
        formData.append('id', this.querySelector('[name=id]').value);
      }

      const productType = this.dataset.productType;

      const quantityInput = (this.form || this).querySelector('input[name="quantity"]');
      if (quantityInput) {
        let quantityValue = parseFloat(quantityInput.value);

        if (productType === 'tejido' || productType === 'tecido') {
          let transformedQuantity = Math.round(quantityValue / 0.25);
          formData.set('quantity', transformedQuantity);
        } else {
          formData.set('quantity', quantityValue);
        }
      }
      
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      const metersKey = this.dataset.metersKey;
      const variantId = formData.get('id');

      const clearMeters = ((productType === 'tejido' || productType === 'tecido') && metersKey)
        ? fetch('/cart.js').then(r => r.json()).then(cart => {
            let chain = Promise.resolve();
            cart.items.forEach((item, index) => {
              if (String(item.variant_id) === String(variantId) && item.properties && item.properties[metersKey]) {
                const newProps = Object.assign({}, item.properties);
                delete newProps[metersKey];
                chain = chain.then(() =>
                  fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ line: index + 1, quantity: item.quantity, properties: newProps })
                  })
                );
              }
            });
            return chain;
          })
        : Promise.resolve();

      clearMeters.then(() => fetch(`${routes.cart_add_url}`, config))
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;

          // Sync meters property for tejido items after add-to-cart (Shopify merges quantities, losing metersKey)
          if ((productType === 'tejido' || productType === 'tecido') && metersKey && window.cartStrings && window.cartStrings.priceKey) {
            const priceKey = window.cartStrings.priceKey;
            fetch('/cart.js')
              .then(r => r.json())
              .then(cart => {
                let chain = Promise.resolve();
                cart.items.forEach((item, index) => {
                  if (String(item.variant_id) === String(variantId) && item.properties && item.properties[priceKey]) {
                    const newMeters = (item.quantity / 4).toFixed(2).replace('.', ',');
                    const updatedProps = Object.assign({}, item.properties);
                    updatedProps[metersKey] = newMeters;
                    chain = chain.then(() =>
                      fetch('/cart/change.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ line: index + 1, quantity: item.quantity, properties: updatedProps })
                      })
                    );
                  }
                });
                return chain;
              });
          }

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
